"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["giftCards"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../giftcards'),
  getGiftCardElements = _require.getGiftCardElements,
  renderAddedGiftCard = _require.renderAddedGiftCard,
  showGiftCardInfoMessage = _require.showGiftCardInfoMessage,
  showGiftCardCancelButton = _require.showGiftCardCancelButton,
  attachGiftCardCancelListener = _require.attachGiftCardCancelListener,
  createElementsToShowRemainingGiftCardAmount = _require.createElementsToShowRemainingGiftCardAmount;
var _require2 = require('../../../../../../../config/constants'),
  GIFTCARD = _require2.GIFTCARD,
  SUCCESS = _require2.SUCCESS,
  NOTENOUGHBALANCE = _require2.NOTENOUGHBALANCE;
var GiftCardConfig = /*#__PURE__*/function () {
  function GiftCardConfig(store, httpClient, helpers) {
    var _this = this;
    _classCallCheck(this, GiftCardConfig);
    _defineProperty(this, "handleBalanceCheckSuccess", function (data, resolve) {
      var _getGiftCardElements = getGiftCardElements(),
        giftCardsInfoMessageContainer = _getGiftCardElements.giftCardsInfoMessageContainer,
        giftCardSelect = _getGiftCardElements.giftCardSelect,
        cancelMainPaymentGiftCard = _getGiftCardElements.cancelMainPaymentGiftCard,
        giftCardAddButton = _getGiftCardElements.giftCardAddButton,
        giftCardSelectWrapper = _getGiftCardElements.giftCardSelectWrapper;
      giftCardSelectWrapper === null || giftCardSelectWrapper === void 0 ? void 0 : giftCardSelectWrapper.classList.add('invisible');
      var initialPartialObject = _objectSpread({}, _this.store.partialPaymentsOrderObj);
      cancelMainPaymentGiftCard.classList.remove('invisible');
      cancelMainPaymentGiftCard.addEventListener('click', function () {
        _this.unmountGiftCardComponent();
        cancelMainPaymentGiftCard.classList.add('invisible');
        giftCardAddButton.style.display = 'block';
        giftCardSelect.value = null;
        Object.assign(_this.store.partialPaymentsOrderObj, initialPartialObject);
      });
      document.querySelector('button[value="submit-payment"]').disabled = true;
      giftCardsInfoMessageContainer.innerHTML = '';
      giftCardsInfoMessageContainer.classList.remove('gift-cards-info-message-container');
      _this.store.partialPaymentsOrderObj.remainingAmountFormatted = data.remainingAmountFormatted;
      _this.store.partialPaymentsOrderObj.totalDiscountedAmount = data.totalAmountFormatted;
      resolve(data);
    });
    _defineProperty(this, "onBalanceCheck", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject, requestData) {
        var payload, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              payload = {
                csrf_token: $('#adyen-token').val(),
                data: JSON.stringify(requestData)
              };
              _context.next = 4;
              return _this.httpClient({
                method: 'POST',
                url: window.checkBalanceUrl,
                data: payload
              });
            case 4:
              data = _context.sent;
              document.querySelector('button[value="submit-payment"]').disabled = false;
              if (data.resultCode === SUCCESS) {
                _this.handleBalanceCheckSuccess(data, resolve);
              } else if (data.resultCode === NOTENOUGHBALANCE && data.balance.value > 0) {
                resolve(data);
              } else {
                reject();
              }
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              reject();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    this.store = store;
    this.httpClient = httpClient;
    this.helpers = helpers;
  }
  return _createClass(GiftCardConfig, [{
    key: "onOrderRequest",
    value: function () {
      var _onOrderRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject, requestData) {
        var paymentMethod, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              paymentMethod = requestData.paymentMethod;
              if (!this.store.adyenOrderDataCreated) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return this.makeGiftCardPaymentRequest(paymentMethod, reject);
            case 5:
              _context2.next = 14;
              break;
            case 7:
              _context2.next = 9;
              return this.httpClient({
                method: 'POST',
                url: window.partialPaymentsOrderUrl,
                data: {
                  csrf_token: $('#adyen-token').val(),
                  data: JSON.stringify(requestData)
                }
              });
            case 9:
              data = _context2.sent;
              if (!(data.resultCode === 'Success')) {
                _context2.next = 14;
                break;
              }
              this.store.adyenOrderDataCreated = true;
              _context2.next = 14;
              return this.makeGiftCardPaymentRequest(paymentMethod, reject);
            case 14:
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](0);
              reject();
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 16]]);
      }));
      function onOrderRequest(_x4, _x5, _x6) {
        return _onOrderRequest.apply(this, arguments);
      }
      return onOrderRequest;
    }()
  }, {
    key: "onSubmit",
    value: function onSubmit(state, component) {
      this.store.selectedMethod = state.data.paymentMethod.type;
      this.store.brand = component === null || component === void 0 ? void 0 : component.displayName;
      var submitButton = document.querySelector('button[value="submit-payment"]');
      document.querySelector('input[name="brandCode"]').checked = false;
      submitButton.disabled = false;
      submitButton.click();
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      var _this2 = this;
      return {
        showPayButton: true,
        onChange: function onChange(state) {
          _this2.store.updateSelectedPayment(GIFTCARD, 'isValid', state.isValid);
          _this2.store.updateSelectedPayment(GIFTCARD, 'stateData', state.data);
        },
        onBalanceCheck: function onBalanceCheck(resolve, reject, requestData) {
          _this2.onBalanceCheck(resolve, reject, requestData);
        },
        onOrderRequest: function onOrderRequest(resolve, reject, requestData) {
          _this2.onOrderRequest(resolve, reject, requestData);
        },
        onSubmit: function onSubmit(state, component) {
          _this2.onSubmit(state, component);
        }
      };
    }
  }, {
    key: "unmountGiftCardComponent",
    value: function unmountGiftCardComponent() {
      var _this$store$component;
      var giftCard = (_this$store$component = this.store.componentsObj) === null || _this$store$component === void 0 ? void 0 : _this$store$component.giftcard;
      if (giftCard) {
        giftCard.node.unmount('component_giftcard');
      }
    }
  }, {
    key: "handlePartialPaymentSuccess",
    value: function handlePartialPaymentSuccess() {
      var _this3 = this,
        _this$store$addedGift;
      var _getGiftCardElements2 = getGiftCardElements(),
        giftCardSelectContainer = _getGiftCardElements2.giftCardSelectContainer,
        giftCardSelect = _getGiftCardElements2.giftCardSelect,
        giftCardsList = _getGiftCardElements2.giftCardsList,
        cancelMainPaymentGiftCard = _getGiftCardElements2.cancelMainPaymentGiftCard,
        giftCardAddButton = _getGiftCardElements2.giftCardAddButton;
      giftCardSelectContainer.classList.add('invisible');
      giftCardSelect.value = null;
      giftCardsList.innerHTML = '';
      cancelMainPaymentGiftCard.addEventListener('click', function () {
        _this3.unmountGiftCardComponent();
        cancelMainPaymentGiftCard.classList.add('invisible');
        giftCardAddButton.style.display = 'block';
        giftCardSelect.value = null;
      });
      this.unmountGiftCardComponent();
      this.store.addedGiftCards.forEach(renderAddedGiftCard);
      if ((_this$store$addedGift = this.store.addedGiftCards) !== null && _this$store$addedGift !== void 0 && _this$store$addedGift.length) {
        showGiftCardInfoMessage();
      }
      showGiftCardCancelButton(true);
      attachGiftCardCancelListener();
      createElementsToShowRemainingGiftCardAmount();
    }
  }, {
    key: "makePartialPayment",
    value: function makePartialPayment(requestData) {
      var _this4 = this;
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
          var response, _document$querySelect, giftCards, rest;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.httpClient({
                  url: window.partialPaymentUrl,
                  method: 'POST',
                  data: {
                    data: JSON.stringify(requestData)
                  }
                });
              case 2:
                response = _context3.sent;
                if (response.error) {
                  reject(new Error("Partial payment error ".concat(response === null || response === void 0 ? void 0 : response.error)));
                } else {
                  giftCards = response.giftCards, rest = _objectWithoutProperties(response, _excluded);
                  _this4.store.checkout.options.amount = rest.remainingAmount;
                  _this4.store.adyenOrderDataCreated = rest.orderCreated;
                  _this4.store.partialPaymentsOrderObj = rest;
                  sessionStorage.setItem('partialPaymentsObj', JSON.stringify(rest));
                  _this4.store.addedGiftCards = giftCards;
                  _this4.helpers.setOrderFormData(response);
                  $('body').trigger('checkout:renderPaymentMethod', {
                    email: (_document$querySelect = document.querySelector('.customer-summary-email')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.textContent,
                    amount: rest.remainingAmount
                  });
                  resolve();
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x7, _x8) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "makeGiftCardPaymentRequest",
    value: function () {
      var _makeGiftCardPaymentRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(paymentMethod, reject) {
        var brandSelect, giftCardBrand, encryptedCardNumber, encryptedSecurityCode, brand;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              brandSelect = document.getElementById('giftCardSelect');
              giftCardBrand = brandSelect.options[brandSelect.selectedIndex].text;
              encryptedCardNumber = paymentMethod.encryptedCardNumber, encryptedSecurityCode = paymentMethod.encryptedSecurityCode, brand = paymentMethod.brand;
              _context4.prev = 3;
              _context4.next = 6;
              return this.makePartialPayment({
                encryptedCardNumber: encryptedCardNumber,
                encryptedSecurityCode: encryptedSecurityCode,
                brand: brand,
                giftCardBrand: giftCardBrand
              });
            case 6:
              this.handlePartialPaymentSuccess();
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              reject();
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 9]]);
      }));
      function makeGiftCardPaymentRequest(_x9, _x0) {
        return _makeGiftCardPaymentRequest.apply(this, arguments);
      }
      return makeGiftCardPaymentRequest;
    }()
  }]);
}();
module.exports = GiftCardConfig;